import { OfflinePaymentEsignPopup } from './OfflinePayment';
import { PaymentFailurePopup } from './PaymentFailure';
import { PaymentPopup } from './PaymentMode';
import { PaymentSuccessPopup } from './PaymentSuccess';

interface PaymentPopupsProps {
  showPaymentSuccessPopup: boolean;
  onCloseSuccessPopup: () => void;
  onPaymentSuccessOk: () => void | Promise<void>;
  successOkDisabled?: boolean;

  showPaymentFailurePopup: boolean;
  onPaymentFailureOk: () => void | Promise<void>;

  showPaymentModePopup: boolean;
  onClosePaymentModePopup: () => void;
  onPaymentModeConfirm: (paymentType: string, paymentMode: string) => void | Promise<void>;
  isOnlinePaymentEnabled: boolean;

  showOfflinePaymentEsignPopup: boolean;
  onCloseOfflinePopup: () => void;
  onProceedWithEsign: () => void | Promise<void>;
  proceedDisabled?: boolean;
}

export function PaymentPopups({
  showPaymentSuccessPopup,
  onCloseSuccessPopup,
  onPaymentSuccessOk,
  successOkDisabled,
  showPaymentFailurePopup,
  onPaymentFailureOk,
  showPaymentModePopup,
  onClosePaymentModePopup,
  onPaymentModeConfirm,
  isOnlinePaymentEnabled,
  showOfflinePaymentEsignPopup,
  onCloseOfflinePopup,
  onProceedWithEsign,
  proceedDisabled,
}: PaymentPopupsProps): JSX.Element {
  return (
    <>
      {showPaymentSuccessPopup && (
        <PaymentSuccessPopup
          onClose={onCloseSuccessPopup}
          onClickOk={onPaymentSuccessOk}
          okDisabled={successOkDisabled}
        />
      )}
      {showPaymentFailurePopup && <PaymentFailurePopup onClickOk={onPaymentFailureOk} />}
      {showPaymentModePopup && (
        <PaymentPopup
          onClose={onClosePaymentModePopup}
          onConfirm={onPaymentModeConfirm}
          isOnlinePaymentEnabled={isOnlinePaymentEnabled}
        />
      )}
      {showOfflinePaymentEsignPopup && (
        <OfflinePaymentEsignPopup
          onClose={onCloseOfflinePopup}
          onProceedWithEsign={onProceedWithEsign}
          proceedDisabled={proceedDisabled}
        />
      )}
    </>
  );
}
